export const getAllBannersHeight = () => {
  const element = document.querySelector('#app-banners')
  if (!element) {
    return 0
  }
  return element.getBoundingClientRect().height
}
